import React from 'react'
import Svg from 'src/Components/shared/Svg'

const BotHeadHexagon = props => (
  <Svg viewBox='0 0 50 54' width={50} height={54} fill='none' {...props}>
    <g filter='url(#prefix__filter0_d)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M48 36.458l-.248-20.384c-.02-1.65-.942-3.183-2.419-4.025L27.075 1.646c-1.477-.841-3.283-.862-4.741-.055L4.322 11.57A4.466 4.466 0 002 15.542l.247 20.385c.021 1.65.942 3.183 2.419 4.024l18.258 10.404c1.477.841 3.283.862 4.741.055l18.013-9.982A4.466 4.466 0 0048 36.457z'
        fill='#535256'
      />
    </g>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M29.451 27.61a2.75 2.75 0 110-5.498 2.75 2.75 0 110 5.498zm-8.925 0a2.75 2.75 0 01-2.752-2.749 2.75 2.75 0 012.752-2.75 2.75 2.75 0 012.752 2.75 2.75 2.75 0 01-2.752 2.748zM17.86 35h14.215c.986 0 1.787-.8 1.787-1.786v-3.028h1.048c.533 0 .964-.43.964-.961v-3.888a.962.962 0 00-.964-.962h-1.048v-3.813c0-.985-.8-1.784-1.787-1.784h-6.612v-1.07a2.824 2.824 0 002.375-2.787 2.823 2.823 0 00-2.825-2.821 2.822 2.822 0 00-.563 5.586v1.092H17.86c-.986 0-1.787.799-1.787 1.784v3.813h-1.062a.962.962 0 00-.962.962v3.888c0 .53.431.961.962.961h1.063v3.028c0 .986.8 1.785 1.787 1.785zm12.105-5.201c.477-.305 1.092-.134 1.373.383.282.516.124 1.182-.353 1.487-.634.406-1.632.703-2.666.903-1.07.207-2.308.334-3.5.334-1.191 0-2.385-.127-3.402-.336-.978-.2-1.921-.502-2.52-.928-.463-.33-.592-1.003-.288-1.504.304-.501.926-.641 1.389-.312.25.178.861.42 1.792.61.892.183 1.96.298 3.03.298 1.07 0 2.19-.115 3.146-.3.993-.192 1.69-.438 2-.635z'
      fill='#BBB2B7'
    />
    <defs>
      <filter
        id='prefix__filter0_d'
        x={0}
        y={0}
        width={50}
        height={54}
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0' />
        <feBlend in2='BackgroundImageFix' result='effect1_dropShadow' />
        <feBlend in='SourceGraphic' in2='effect1_dropShadow' result='shape' />
      </filter>
    </defs>
  </Svg>
)

export default BotHeadHexagon
